import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type FinderApplicationPrivateModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPrivateModuleSpecs';
// eslint-disable-next-line max-len
import { type FinderApplicationPublicModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPublicModuleSpecs';
import ApplicationModuleVehicleAssignments from '../shared/ApplicationModuleVehicleAssignments';

export type UpdateVehicleAssignmentsValue = {
    dealerVehicles: Record<string, string[]>;
};

export type VehicleAssignmentsProps = {
    module: FinderApplicationPublicModuleSpecsFragment | FinderApplicationPrivateModuleSpecsFragment;
};

const VehicleAssignments = ({ module }: VehicleAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleVehicleAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.vehicles.noData')}
        />
    );
};

export default VehicleAssignments;
